<template>
  <v-select
    v-model="region_id"
    :label="`${$t('REGIONS.ITEM')} *`"
    item-value="id"
    item-text="name"
    :items="regionsList"
    v-bind="$attrs"
    @change="updateRegion"
  />
</template>

<script>
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'OrderRegion',

  props: {
    value: {
      type: Number,
      default: null
    },
    zip: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      region_id: null,
      regionsList: []
    };
  },

  watch: {
    zip: 'getRegion'
  },

  created() {
    this.region_id = this.value;
    if (this.region_id === null) {
      this.getRegion();
    }
  },

  mounted() {
    this.retrieveRegions().then(({ data }) => {
      this.regionsList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('region', ['retrieveRegionByZip', 'retrieveRegions']),

    getRegion() {
      if (
        this.zip &&
        this.zip.toString().length >= 4 &&
        this.zip.toString().length <= 5
      ) {
        this.retrieveRegionByZip(this.zip)
          .then(({ data }) => {
            this.region_id = data.data.id;
            this.$emit('input', this.region_id);
          })
          .catch(error => {
            this.error = error;
          });
      } else {
        this.region_id = this.value;
        this.$emit('input', this.region_id);
      }
    },

    updateRegion() {
      this.$emit('input', this.region_id);
    }
  }
};
</script>

<style scoped></style>
